<div class="container-fluid">
    <div class="row">

        <div class="col-md-4 col-offset-2 mt-4">

            <form class="example-form" [formGroup]="addClient">
                <mat-card class="registerForm">
                    <mat-card-header>
                        <mat-card-title>
                            Add Client
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row">
                            <mat-form-field class="example-full-width col-md-12">
                                <input matInput placeholder="Client/Company name" formControlName="client">
                            </mat-form-field>
                            <mat-form-field class="example-full-width col-md-12">
                                <mat-select placeholder="Profession" formControlName="profession">
                                    <mat-option *ngFor="let  profession of professions" [value]="profession.value">
                                        {{ profession.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                          
                            <mat-form-field class="example-full-width col-md-12">
                                <input matInput placeholder="Email" formControlName="emailid">
                            </mat-form-field>
                            <div class="text-danger col-md-12"
                                *ngIf="addClient['controls']['emailid']['invalid'] && addClient['controls']['emailid']['touched']">
                                Email not valid
                            </div>

                            <mat-form-field class="example-full-width col-md-12">


                                <input type="password" #input matInput placeholder="Password" formControlName="pass">

                                <mat-icon (click)="showPassword(input)" class="passicon">{{sign}}</mat-icon>


                            </mat-form-field>



                            <div class="text-danger col-md-12"
                                *ngIf="addClient['controls']['pass']['invalid'] && addClient['controls']['pass']['touched']">
                                Please enter password
                            </div>
                            <mat-form-field class="example-full-width col-md-12">
                                <input type="number" matInput placeholder="Phone number" formControlName="mobile">
                            </mat-form-field>

                        </div>





                    </mat-card-content>
                    <mat-card-actions>
                        <div class="register">
                            <button class="back" (click)="back()" type="button" mat-raised-button
                                color="primary">Back</button>
                            <button id="add" class="ml-4" [disabled]="!addClient.valid"
                                (click)="onSubmitUser()" type="button" mat-raised-button color="primary">Add
                                client</button>


                        </div>
                    </mat-card-actions>
                </mat-card>

            </form>
        </div>

    </div>
</div>